import { translationEndpoints } from "@lookiero/sty-psp-i18n";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { bootstrap as lookAndLikeBootstrap } from "./src/infrastructure/delivery/bootstrap";
import { root } from "./src/infrastructure/ui/Root";
import { RELEASE } from "./src/version";
const bootstrap = ({ apiUrl, getAuthToken, sentry }) => {
    const { Component: Messaging } = lookAndLikeBootstrap({ apiUrl, getAuthToken });
    return {
        root: root({ Messaging, sentry }),
    };
};
export { bootstrap, translationEndpoints, Tradename, RELEASE };
